module.exports = __webpack_public_path__ + "img/L_304_0.beb7e38a.png";